import React from 'react';

import {
  DEDICATED_JOURNEY_PATH,
  GENERIC_ERROR_MESSAGE,
  getProductType,
  isNLD_OR_LL,
  ROUTES,
  NOTIFICATION_TIMEOUT,
  ORDER_TYPE,
  PRODUCT_NAME,
  PRODUCT_TYPE,
  STORAGE_KEY,
  ACCORDION_VARIANTS,
  USER_TYPE_KAM,
  USER_TYPE,
  MOENGAGE_ANALYTICS_EVENT,
  ORDER_SUBMITTED_POST_STATUS,
  isShiftingJourney,
  META_TAGS
} from 'common/constants/app.constants';
import { v4 as uuidv4 } from 'uuid';
import queryString from 'query-string';
import moment from 'moment';
import EventManager from '../services/event-manager.service';
import {
  AUTHORIZATION_HEADER,
  AUTHORIZED_SIGNATORY,
  CUSTOMER_DETAIL,
  DEDICATED_CUSTOMER_DETAIL,
  DEDICATED_FEASIBILITY_DATA,
  DEDICATED_FEASIBILITY_RESPONSE,
  DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL,
  FEASIBILITY_DATA,
  FEASIBILITY_RESPONSE,
  INSTALLATION_PAGE_CUSTOMER_DETAIL,
  MODULE_ID,
  PROFILE_DATA,
  PRODUCT_LIST,
  SUMMARY_AUTHORIZATION_HEADER,
  SELECTED_PARTY_ACCOUNT,
  SELECTED_PARTY_DATA,
  UNAUTH_ACTIVE_STEP
} from '../../home/common/constants/constants';
import {
  ERROR_TOAST,
  SUCCESS_TOAST,
  WARNING_TOAST,
  AUTH_TOKEN,
  LEAD_ID,
  MULTI_SITE_MODULE_ID,
  ORDER_ID,
  SUMMARY_AUTH_TOKEN,
  SERVICE_TYPE_LIST,
  DEFAULT_TOAST_MSG,
  CART_ID,
  ORDER_CONFIRMATION,
  FEASIBILITY_SUCCESS
} from 'home/view/manage-feasibility/constants';
import { LEAD, ORDER } from 'tokenGeneration/constant';
// import { NOTIFICATION_TYPE } from 'common/components/notification-component/notification-component';
import { NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';
import { ERROR_MESSAGE } from 'rateCard/constant/constant';
import config, { ENV_NAME } from 'config/config';
import { getLead } from 'home/view/manage-feasibility/services/multiSite-service';
import { getCurrentOrder, saveLead } from 'tokenGeneration/lead.util';
import axiosInstance from 'home/view/manage-feasibility/services/axios-config';
import { faOnDedicatedAuthCheckFeasibiliyPage, faOnDedicatedProceedClick } from 'dedicated/services/analytics.service';
import { createLead, createSiebelLead, addDiConnectionDetails } from 'common/helper/api.helper';

import MeterImg1 from 'assests/meter1.png';
import MeterImg2 from 'assests/meter2.png';
import MeterImg3 from 'assests/meter3.png';
import MeterImg4 from 'assests/meter4.png';
import MeterImg5 from 'assests/meter5.png';
import { trackMOEEvent } from 'common/services/moengage.service';
import { trackGTM } from 'app-layout/utils';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';

const CryptoJS = require('crypto-js');
const airtelE_D_Key = 'A!rt3lOnl!n33ncrypt30n5tr!ngHJS3cur!ty';

var serviceStore = {};
let timer;

export const correlation = () => {
  return uuidv4();
};
export const generateKey = () => {
  let date = new Date();
  let components = [date.getYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()];
  return CryptoJS.SHA1((components.join('') + Math.random()).replace('.', '')).toString();
};

export const encryptDataToSHAString = (data, key) => {
  let string = CryptoJS.DES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString();
  return string;
};

export const decryptDatafromKey = (data, key) => {
  let string = CryptoJS.DES.decrypt(data.replace('"', ''), CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString(CryptoJS.enc.Utf8);
  return string;
};

export const isMobileApp = () => {
  return typeof MyAirtelAppReact !== 'undefined';
};

export const showLoader = (show) => {
  EventManager.publish('loader', show);
};

export const isMobile = () => {
  var mobileCheck = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return mobileCheck.Android() || mobileCheck.BlackBerry() || mobileCheck.iOS() || mobileCheck.Opera() || mobileCheck.Windows();
    }
  };
  return mobileCheck.any() ? true : false;
};

export const findParamFromUrl = (param, isBase64) => {
  let queryParams = getQueryString();
  if (queryParams.hasOwnProperty(param) && queryParams[param]) {
    if (isBase64) {
      return JSON.parse(atob(queryParams[param]));
    }
    return queryParams[param];
  }
};

export const getQueryString = () => {
  let queryString = (window && window.location && window.location.search) || '';
  let resultObj = {};
  queryString = queryString.substring(1);
  queryString = queryString.split('&');
  queryString.forEach((keyVal) => {
    let key = keyVal.substring(0, keyVal.indexOf('='));
    let value = keyVal.substring(keyVal.indexOf('=') + 1);
    resultObj[key] = value;
  });
  return resultObj;
};

export const getEncryptedString = (message) => {
  if (!message) return message;
  if (typeof message === 'object') {
    message = JSON.stringify(message);
  } else {
    message = String(message);
  }
  let keyHex = CryptoJS.enc.Utf8.parse(airtelE_D_Key);
  let encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};

export const getDecryptedString = (ciphertext) => {
  if (!ciphertext) return ciphertext;
  let keyHex = CryptoJS.enc.Utf8.parse(airtelE_D_Key);
  // direct decrypt ciphertext
  let decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  let message = decrypted.toString(CryptoJS.enc.Utf8);

  //if encryption source was object
  try {
    message = JSON.parse(message);
    return message;
  } catch (err) {
    //if encryption source was string
    return message;
  }
};

export const isLocalStorageSupported = () => {
  let testKey = 'test',
    storage = window.localStorage;
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

export const setInLocalStorage = (moduleId, key, obj) => {
  if (isLocalStorageSupported()) {
    const cipherText = getEncryptedString(obj);
    localStorage[moduleId + key] = cipherText;
  }
};

export const getFromLocalStorage = (moduleId, key) => {
  if (isLocalStorageSupported()) {
    let fromLocalStorage = getDecryptedString(localStorage[moduleId + key]);
    return fromLocalStorage ? fromLocalStorage : '';
  }
};

export const removeFromLocalStorage = (moduleId, key) => {
  if (localStorage[moduleId + key]) {
    delete localStorage[moduleId + key];
  }
};

export const removeAllFromLocalStorage = (moduleId, skipTheseLocalStorage) => {
  for (var prop in localStorage) {
    if (prop.indexOf(moduleId) === 0 && prop !== moduleId + skipTheseLocalStorage) {
      delete localStorage[prop];
    }
  }
};

export const navigateTo = (url) => {
  window.location.href = url;
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const scrollToRef = (ref) => {
  ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //window.scrollBy(0, 10);
};

export const scrollCustom = (ref) => {
  window.scrollTo({ top: 310, behavior: 'smooth' });
  //window.scrollBy(0, 10);
};

export const showServiceError = (params) => {
  EventManager.publish('serviceError', { show: false });
  if (params.show === true) {
    EventManager.publish('serviceError', {
      show: params.show,
      data: params.data,
      redirect: params.redirect
    });
  }
};

export const showNotification = (params) => {
  let timeOut = params.timer ? params.timer : NOTIFICATION_TIMEOUT;
  if (timer) {
    clearTimeout(timer);
  }
  EventManager.publish('notify', { show: false });
  if (params.show === true) {
    EventManager.publish('notify', params);
    timer = setTimeout(() => {
      EventManager.publish('notify', { show: false });
    }, timeOut * 1000);
  }
};

export const setInSessionStorage = (moduleId, key, obj) => {
  if (isLocalStorageSupported()) {
    let cipherText = getEncryptedString(obj);
    let sessionStorage = window.sessionStorage;
    sessionStorage[moduleId + key] = cipherText;
  } else {
    if (typeof obj == 'object') {
      obj = JSON.stringify(obj);
    }
    var value = [
      {
        cname: moduleId + key,
        cvalue: obj
      }
    ];
    setInCookie(value);
  }
};

export const removeFromSessionStorage = (moduleId, key) => {
  let sessionStorage = window.sessionStorage;
  if (sessionStorage[moduleId + key]) {
    delete sessionStorage[moduleId + key];
  }
};

export const getFromSessionStorage = (moduleId, key, remove) => {
  // ;
  let sessionStorage = window.sessionStorage;
  let val;
  if (isLocalStorageSupported()) {
    val = getDecryptedString(sessionStorage[moduleId + key]);
  } else {
    val = getFromCookie(moduleId + key);
    if (val && (val[0] === '{' || val[0] === '[')) {
      val = JSON.parse(val);
    }
  }
  if (remove) removeFromSessionStorage(moduleId, key);
  return val;
};

export const getFromCookie = (cname) => {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const setInCookie = (value) => {
  for (let i = 0; i < value.length; i++) {
    if (value[i].cexpire !== undefined) {
      document.cookie = value[i].cname + '=' + value[i].cvalue + ';expires=' + value[i].cexpire + ';path=/';
      document.cookie = value[i].cname + '=' + value[i].cvalue + ';expires=' + value[i].cexpire + ';path=/;domain=airtel.in';
    } else {
      document.cookie = value[i].cname + '=' + value[i].cvalue + ';path=/';
      document.cookie = value[i].cname + '=' + value[i].cvalue + ';path=/;domain=airtel.in';
    }
  }
  return '';
};

export const exportToCsv = (filename, rows) => {
  var processRow = function (row) {
    var finalVal = '';
    for (var j = 0; j < row.length; j++) {
      var innerValue = row[j] === null ? '' : row[j].toString();
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      }
      var result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
      if (j > 0) finalVal += ',';
      finalVal += result;
    }
    return finalVal + '\n';
  };

  var csvFile = '';
  for (var i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

export const setMetaTags = (data) => {
  let getParams = queryString.parse(window && window.location.search);
  let productType = getParams && getParams.productType;
  if (productType && productType !== PRODUCT_TYPE.VPN) {
    productType = 'Dedicated Internet';
  }
  let checkProduct = productType ? productType : getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN ? PRODUCT_TYPE.VPN : 'Dedicated Internet';
  let title = 'Internet Leased Line: High-Speed ' + checkProduct + ' Connection for Business';
  if (getParams && getParams.productType === 'DSL') {
    data.title = META_TAGS.AOI_CHECK_FEASIBLITY.title;
    data.ogTitle = META_TAGS.AOI_CHECK_FEASIBLITY.title;
  } else {
    data.title = title;
    data.ogTitle = title;
  }

  if (data) {
    let title = document.querySelector('title');
    title.innerHTML = data.title ? data.title : '';
    let keywordsTag = document.querySelector('meta[name="keywords"]');
    setTagsAttribute(keywordsTag, 'content', data.keywords || '');

    let descriptionTag = document.querySelector('meta[name="description"]');
    setTagsAttribute(descriptionTag, 'content', data.desc || '');

    let canonicalTag = document.querySelector('link[rel="canonical"]');
    setTagsAttribute(canonicalTag, 'href', data.canonical || '');

    let og_urlTag = document.querySelector('meta[property="og:url"]');
    setTagsAttribute(og_urlTag, 'content', data.ogUrl || '');

    let og_titleTag = document.querySelector('meta[property="og:title"]');
    setTagsAttribute(og_titleTag, 'content', data.ogTitle || '');

    let og_imageTag = document.querySelector('meta[property="og:image"]');
    setTagsAttribute(og_imageTag, 'content', data.ogTitleImage || '');

    let og_site_nameTag = document.querySelector('meta[property="og:site_name"]');
    setTagsAttribute(og_site_nameTag, 'content', data.ogSiteName || '');

    let og_descriptionTag = document.querySelector('meta[property="og:description"]');
    setTagsAttribute(og_descriptionTag, 'content', data.ogDesc || '');
  }
};

function setTagsAttribute(htmlElement, property, value) {
  if (htmlElement) {
    htmlElement.setAttribute(property, value);
  }
}
export const getRouteBasedUILog = () => {
  let ui_log_data = {
    errorPushInterval: 5 * 1000, // It represents 5 sec
    applicationName: 'SELFCARE_WEB',
    apiEndPoint: 'https://www.airtel.in/homes-api/utilities/rest/logger/bulkLog',
    releaseVersion: '',
    errorType: 'b2b-error',
    messageType: 'b2b-message',
    defaultErrorHandler: false
  };
  return ui_log_data;
};

/*!
 * Check if two objects or arrays are equal
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object|Array}  value  The first object or array to compare
 * @param  {Object|Array}  other  The second object or array to compare
 * @return {Boolean}              Returns true if they're equal
 */
export const isEqual = (value, other) => {
  // Get the value type
  let type = Object.prototype.toString.call(value);

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) return false;

  // If items are not an object or array, return false
  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

  // Compare the length of the length of the two items
  let valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
  let otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
  if (valueLen !== otherLen) return false;

  // Compare two items
  let compare = function (item1, item2) {
    // Get the object type
    let itemType = Object.prototype.toString.call(item1);

    // If an object or array, compare recursively
    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false;
    }

    // Otherwise, do a simple comparison
    else {
      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) return false;

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false;
      } else {
        if (item1 !== item2) return false;
      }
    }
  };

  // Compare properties
  if (type === '[object Array]') {
    for (let i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false;
    }
  } else {
    for (let key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false;
      }
    }
  }

  // If nothing failed, return true
  return true;
};

export const stopBackgroundScrolling = (value) => {
  let document = window && window.document && window.document.body;
  if (value) {
    if (document) {
      var orig = document.className;
      document.className = orig + (orig ? ' ' : '') + 'no-scroll';
    }
  } else {
    if (document) {
      document.className = '';
    }
  }
};
export const setAnalyticsParamsforDedicated = (data) => {
  data.prop0 = `b2b|dedicated internet`;
  try {
    trackAnalytics(data);
  } catch (error) {
    console.log('Error while sending Analytics Data. Error -');
    console.log(error);
  }
};

export const setAnalyticsParamsforDedicatedAuth = (data) => {
  const productType = getFromSessionStorage(MODULE_ID, PRODUCT_NAME);
  data.prop0 = 'b2b|enterprise|dedicated internet';
  if (productType === PRODUCT_TYPE.VPN) {
    data.prop0 = 'b2b|enterprise|airtel-vpn';
  }
  try {
    trackAnalytics(data);
  } catch (error) {
    console.log('Error while sending Analytics Data. Error -');
    console.log(error);
  }
};

export const trackAnalytics = (data) => {
  console.log('trackAnalytics :-', data);
  if (!data) return;
  try {
    if (typeof window.ClickStream !== 'undefined') {
      window.ClickStream.trackEvent(data);
    }
  } catch (error) {
    console.log('Error while sending data to Analytics Service');
    console.log(error);
  }
};
export const gtag_report_conversion = (url) => {
  let callback = function () {
    if (typeof url != 'undefined') {
      window.location = url;
    }
  };
  window &&
    window.gtag('event', 'conversion', {
      send_to: 'AW-758704667/hciICOX5r6gBEJvU4-kC',
      event_callback: callback
    });
  return false;
};
export const facebookSmbLead = (data) => {
  window && window.fbq('track', data);
};
export const googleOrderPixel = () => {
  window &&
    window.gtag('event', 'conversion', {
      send_to: 'AW-758704667/EVy4CM-frf0BEJvU4-kC',
      value: 0.0,
      currency: 'INR'
    });
};
export const googleRefer = () => {
  window &&
    window.gtag('event', 'conversion', {
      send_to: 'AW-758704667/NzQSCN2wrf0BEJvU4-kC',
      value: 0.0,
      currency: 'INR'
    });
};
export const numberWithCommas = (number) => {
  return number.toString().split('.')[0].length > 3
    ? number
        .toString()
        .substring(0, number.toString().split('.')[0].length - 3)
        .replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
        ',' +
        number.toString().substring(number.toString().split('.')[0].length - 3)
    : number.toString();
};

export const getCurrentServiceType = (currentServiceType) => {
  const serviceItem = SERVICE_TYPE_LIST.find((item) => item?.id === currentServiceType);

  return serviceItem?.displayName || currentServiceType;
};

export const formatDate = (date) => {
  let month = String(date.getMonth() + 1);
  let day = String(date.getDate());
  const year = String(date.getFullYear());

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return `${day}/${month}/${year}`;
};

export const getUserNameFor = (name) =>
  name
    .match(/(\b\S)?/g)
    .join('')
    .match(/(^\S|\S$)?/g)
    .join('')
    .toUpperCase();

export function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  let byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  let ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  let ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  let blob = new Blob([ab], { type: mimeString });
  return blob;
}

export const formateDateToLocaleStringWithTime = (rawDate = new Date()) => {
  const date = new Date(rawDate);
  const dateWithMonth = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short'
  });

  const timeWithTwelveHour = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });

  return `${dateWithMonth}, ${date.getFullYear()}, ${timeWithTwelveHour}`;
};

export const capitalizeText = (text) => {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
};

export const toUpperCaseWrapper = (text) => {
  return typeof text === 'string' ? text?.toUpperCase() : text;
};

export const convertBandwidthInMbps = (dataList) => {
  let bandwidthList = dataList;
  let bandwidths =
    bandwidthList &&
    bandwidthList.length > 0 &&
    bandwidthList.map((item, index) => {
      let split = item.speed.split(' ');
      let speed = item.speed;
      if (split && split.length > 1 && split[1] && split[1].toLowerCase() === 'gbps') {
        speed = parseInt(split[0]) * 1024 + ' Mbps';
      }
      bandwidthList[index].speed = speed;
    });
  return bandwidthList;
};

export const saveOrderConfirmationInfo = (params) => {
  const type = params && params.type;
  if (type === ORDER_TYPE.ORDER_CONFIRMATION) {
    const orderId = params && params.orderId;
    const auth_token = params && params.auth;

    setInSessionStorage(MODULE_ID, AUTHORIZATION_HEADER, auth_token);
    setInSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN, auth_token);
  }
};

export const convertTimeStamp = (timeStamp) => {
  if (timeStamp) {
    return moment(timeStamp).format('h:mm a - DD MMM YY');
  }

  return '';
};

export const removeUserSessionData = () => {
  removeFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY);
  removeFromSessionStorage(MODULE_ID, 'AehLob');
  removeFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
  removeFromSessionStorage(MODULE_ID, CUSTOMER_DETAIL);
  removeFromSessionStorage(MODULE_ID, INSTALLATION_PAGE_CUSTOMER_DETAIL);
  removeFromSessionStorage(MODULE_ID, FEASIBILITY_DATA);
  removeFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
  removeFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_DATA);
  removeFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
  removeFromSessionStorage(MODULE_ID, PRODUCT_NAME);
  removeFromSessionStorage(MODULE_ID, DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL);

  removeFromSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL);
  removeFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER);
  removeFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
  removeFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);
  removeFromSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID);
  removeFromSessionStorage(MULTI_SITE_MODULE_ID, ORDER_ID);
  removeFromSessionStorage(MULTI_SITE_MODULE_ID, FEASIBILITY_SUCCESS);
  removeFromSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE);
  removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);
  removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_DATA);
  removeFromSessionStorage(MODULE_ID, LEAD);
  removeFromSessionStorage(MODULE_ID, ORDER);
  removeFromSessionStorage(MODULE_ID, UNAUTH_ACTIVE_STEP);
};

export const numberSort = (number1, number2) => number1 - number2;

export const handleError = async (error) => {
  let errorMsg = (error && error.response && error.response.data && error.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;
  if (
    error &&
    error.request.responseType === 'blob' &&
    error.response.data instanceof Blob &&
    error.response.data.type &&
    error.response.data.type.toLowerCase().indexOf('json') != -1
  ) {
    errorMsg = JSON.parse(await error.response.data.text())?.errorMsg;
  }
  if (errorMsg.includes('Invalid User Type')) {
    errorMsg = ERROR_MESSAGE.UN_AUTHORIZED_TITLE;
  }
  showServiceError({
    show: true,
    data: errorMsg,
    redirect: false
  });
};
export const removeConfirmOrderStorage = () => {
  removeFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER);
  removeFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
  removeFromSessionStorage(MULTI_SITE_MODULE_ID, ORDER_ID);
};

export const unAuthPlanPageGtags = () => {
  window && window.gtag('event', 'conversion', { send_to: 'AW-758704667/Fno6CLLLq8IDEJvU4-kC' });
};
export const thankYouPageGtags = () => {
  window && window.gtag('event', 'conversion', { send_to: 'AW-758704667/JzGzCL3P-cEDEJvU4-kC' });
};
export const gtag_report_conversion_customer_details = (url) => {
  var callback = function () {
    if (typeof url != 'undefined') {
      window.location = url;
    }
  };
  window &&
    window.gtag('event', 'conversion', {
      send_to: 'AW-697112697/ike5CO2q1dMDEPmwtMwC',
      event_callback: callback
    });
  return false;
};
export const gtag_report_conversion_lead_submitted = (url) => {
  var callback = function () {
    if (typeof url != 'undefined') {
      window.location = url;
    }
  };
  window &&
    window.gtag('event', 'conversion', {
      send_to: 'AW-697112697/DjDwCNuCkNMDEPmwtMwC',
      value: 1.0,
      currency: 'INR',
      event_callback: callback
    });
  return false;
};

export const getRange = (start, end, step = 1) => {
  const range = [];
  const typeofStart = typeof start;
  const typeofEnd = typeof end;

  if (step === 0) {
    throw TypeError('Step cannot be zero.');
  }

  if (typeofStart == 'undefined' || typeofEnd == 'undefined') {
    throw TypeError('Must pass start and end arguments.');
  } else if (typeofStart != typeofEnd) {
    throw TypeError('Start and end arguments must be of same type.');
  }

  if (end < start) {
    step = -step;
  }

  if (typeofStart == 'number') {
    while (step > 0 ? end >= start : end <= start) {
      range.push(start);
      start += step;
    }
  } else if (typeofStart == 'string') {
    if (start.length != 1 || end.length != 1) {
      throw TypeError('Only strings with one character are supported.');
    }

    start = start.charCodeAt(0);
    end = end.charCodeAt(0);

    while (step > 0 ? end >= start : end <= start) {
      range.push(String.fromCharCode(start));
      start += step;
    }
  } else {
    throw TypeError('Only string and number types are supported');
  }

  return range;
};

export const getLOBs = () => {
  const storeLobs = JSON.parse(localStorage.getItem('userLobs') || {});
  let lobs = 'Data';
  if (storeLobs) {
    console.log(Object.entries(storeLobs));
    const [[, data]] = Object.entries(storeLobs);
    lobs = data || 'data';
  }
  return lobs;
};

export const redirectUserToDirectVPN = () => {
  if (isNLD_OR_LL() && config.env !== ENV_NAME.DEV) {
    window.location = config?.directVPNPageUrl;
  }
};

export const getOrderDetails = (orderId) => {
  return { orderId: orderId || getFromSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID), product: getProductType() || '' };
};
export const isDedicatedJourney = () => {
  return document?.location?.pathname?.includes(DEDICATED_JOURNEY_PATH);
};

export const registerUrlListner = (event) => {
  let getEvent = event && event.target;
  window.addEventListener('beforeunload', () => {
    const redirectionUrl = document?.activeElement?.pathname;
    const isDedicatedApp = redirectionUrl?.includes(DEDICATED_JOURNEY_PATH);
    if (!isDedicatedApp && redirectionUrl) {
      removeUserSessionData();
    } else if (getEvent && getEvent.innerText && getEvent.innerText.toLowerCase() === 'dashboard') {
      removeUserSessionData();
    }
  });
};

export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const getNotificationType = (toastType) => {
  let notificationType = NOTIFICATION_TYPE.DEFAULT;

  switch (toastType) {
    case SUCCESS_TOAST: {
      notificationType = NOTIFICATION_TYPE.SUCCESS;
      break;
    }

    case ERROR_TOAST: {
      notificationType = NOTIFICATION_TYPE.ERROR;
      break;
    }

    case WARNING_TOAST: {
      notificationType = NOTIFICATION_TYPE.WARNING;
      break;
    }

    case ORDER_CONFIRMATION: {
      notificationType = NOTIFICATION_TYPE.ORDER_CONFIRMATION;
      break;
    }

    default: {
      notificationType = NOTIFICATION_TYPE.DEFAULT;
    }
  }

  return notificationType;
};

export const removeAsciiCode = (value) => {
  return value?.replace(/(\r\n|\n|\r)/gm, ' ').replace(/[^\x00-\x7F]/g, ' ');
};
/**
 * Function to set URLs for test server dependencies
 */
export const setEnvUrls = (config, env) => {
  if ([ENV_NAME.DEV, ENV_NAME.PREPROD2, ENV_NAME.PREPROD4, ENV_NAME.QA, ENV_NAME.QA2, ENV_NAME.DEV].includes(env)) {
    // config.profileBaseUrl = 'https://test.airtel.in/ks/app/atb-api-t14/airtel-b2b-profile/rest/';
    // config.connectionBaseUrl = 'https://test.airtel.in/ks/app/atb-api-t14/airtel-b2b-connection/rest/';
    // config.bffBaseUrl = 'https://test.airtel.in/ks/app/atb-api-t14/airtel-aeh-bff/rest/';
    // config.notificationBaseUrl = 'https://test.airtel.in/ks/app/atb-api-t14/b2b-notification-manager/rest/';
    // config.productBasePageUrl = 'http://localhost:3000/business/thanksforbusiness/selfcare/:lob/:product/:inventoryRoute/dashboard';
    // config.contactUsPageUrl = 'https://www.airtel.in/business/b2b/contact-us';

    config.profileBaseUrl = 'https://test.airtel.in/ks/app/atb-integration/airtel-b2b-profile/rest/';
    config.connectionBaseUrl = 'https://test.airtel.in/ks/app/atb-integration/airtel-b2b-connection/rest/';
    config.bffBaseUrl = 'https://test.airtel.in/ks/app/atb-integration/airtel-aeh-bff/rest/';
    config.notificationBaseUrl = 'https://test.airtel.in/ks/app/atb-integration/b2b-notification-manager/rest/';
    config.productBasePageUrl = 'http://localhost:3000/business/thanksforbusiness/selfcare/:lob/:product/:inventoryRoute/dashboard';
    config.contactUsPageUrl = 'https://www.airtel.in/business/b2b/contact-us';
  }
  return config;
};

export const removeLastString = (value) => {
  return value && value?.substring(0, value?.length - 1);
};

export const removeUnderScoreWithSpace = (value) => {
  return value?.split('_').join(' ') ?? '';
};

export const getAccordionVariant = (isUnAuthJourney) => {
  let variant = ACCORDION_VARIANTS.ARROW_WITH_TEXT;

  if (!isUnAuthJourney) {
    variant = ACCORDION_VARIANTS.ROUND;
  }

  return variant;
};

export const addressRegexValidator = (value) => {
  const addressRegex = /^([A-Za-z0-9 &:)(.#_',-\/\^])+$/;
  return addressRegex.test(value[value.length - 1]); // picking up last character of the value to compare
};

export const facebookNextButtonTag = () => {
  window &&
    window.fbq('track', 'Next', {
      content_name: 'Next'
    });
};

export const facebookProceedButtonTag = () => {
  window &&
    window.fbq('track', 'Proceed', {
      content_name: 'Proceed'
    });
};

export const calculateDaysBetween = (d1, d2) => {
  const diff = Math.abs(d1.getTime() - d2.getTime());
  return Math.floor(diff / (1000 * 60 * 60 * 24));
};
export const fetchLead = () => {
  const user = findParamFromUrl('user');
  const isKAM = user === USER_TYPE_KAM;
  const isPnQ = isKAM || isSingleUpgradeOrShiftingJourney();
  return getLead(isPnQ);
};

export const isTMORedirect = findParamFromUrl('journey', false) === 'trackLead';

export const redirectToATBDashboardPage = () => {
  const partyIdFromParams = findParamFromUrl('partyId', false);
  const productTypeFromParams = findParamFromUrl('productType', false);

  const queryString = `partyId=${partyIdFromParams}&productType=${productTypeFromParams}`;
  const redirectUri = config.aehdashboardUrl + `?${queryString}`;

  navigateTo(redirectUri);
};

export const updateParamsToTmo = (leadResponse) => {
  const tmoQueryParams = {};
  const savedPartyId = getFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);
  const savedProductType = getFromSessionStorage(MODULE_ID, PRODUCT_NAME);
  const savedUserType = getFromSessionStorage(MODULE_ID, USER_TYPE);
  const orderId = findParamFromUrl('orderId', false); // fetch lead doesn't have orderId
  const cartId = findParamFromUrl('cartId', false) ?? getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID); // fetch lead doesn't have orderId

  tmoQueryParams['platform'] = 'AEH';
  tmoQueryParams['partyId'] = savedPartyId;
  tmoQueryParams['productType'] = savedProductType;
  tmoQueryParams['user'] = savedUserType;
  tmoQueryParams['leadId'] = leadResponse?.leadId;

  if (isTMORedirect) {
    tmoQueryParams['journey'] = findParamFromUrl('journey', false);
  }

  if (orderId) {
    tmoQueryParams['orderId'] = orderId;
  }

  if (cartId) {
    tmoQueryParams['cartId'] = cartId;
  }

  if (isDevEnv() && isAuthForDev()) {
    tmoQueryParams['isAuth'] = findParamFromUrl('isAuth', false);
  }

  const updatedURI = window?.location?.pathname + '?' + queryString.stringify(tmoQueryParams);

  window.history.replaceState(null, null, updatedURI);
};

export const isNull = (data) => {
  return data === null || data === undefined || data === '';
};

export function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export const debounce = (fn, delay) => {
  let timeoutId;

  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

export const throttle = (fn, delay) => {
  let last = 0;

  return (...args) => {
    let now = new Date().getTime();
    if (now - last < delay) {
      return;
    }

    last = now;
    fn(...args);
  };
};
export const removeEmptyValuesObj = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, value]) => !isNull(value)));

export const getBulkUpgradeDownloadError = async (err) => {
  const error = await err?.response?.data?.text();
  const parsedError = JSON.parse(error);
  return parsedError?.errorMsg || DEFAULT_TOAST_MSG;
};

export const checkIfObjectHasValue = (object) => {
  if (!object) return false;
  return Object.keys(object).length ? true : false;
};

export const isLandingPage = () => {
  return window?.location?.pathname?.includes(ROUTES.DEDICATED_HOME) ?? false;
};

export const isSiteReadinessPage = () => {
  return window?.location?.pathname?.includes(ROUTES.CONFIRM_INSTALLATION) ?? false;
};

export const isEDLJourney = () => {
  return window?.location?.pathname?.includes(ROUTES.EXPRESS_DELIVERY_PAGE_LOGIN) || window?.location?.pathname?.includes(ROUTES.EXPRESS_DELIVERY_PAGE_ORDER) || false;
};

export const checkOrderConfirmationStatusPending = () => {
  const order = getCurrentOrder?.();
  const orderStatus = order?.orderStatus;

  return (orderStatus && [ORDER_TYPE.ORDER_CONFIRMATION, ORDER_TYPE.ORDER_CONFIRMATION_PENDING])?.includes(orderStatus) || isOrderConfirmationUrl();
};

export const isDevEnv = () => {
  return config.env === ENV_NAME.DEV;
};

export const isAuthForDev = () => {
  const isAuth = findParamFromUrl('isAuth', false);
  return isAuth === 'true';
};

export const setAuthTokens = ({ accessToken, refreshToken }) => {
  localStorage?.setItem('accessToken', accessToken);
  localStorage?.setItem('refreshToken', refreshToken);
};

export const setAxiosInstanceBaseUrl = (url) => {
  axiosInstance.defaults.baseURL = url;
};

export const scrollToDiv = (id) => {
  const element = document.getElementById(id);
  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition - 100;
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
};

export const getVisibleFormFields = (form) => {
  const formCopy = Object.assign({}, form);
  Object.entries(formCopy).forEach(([key, value]) => {
    const { hide } = value;
    if (hide) {
      delete formCopy[key];
    }
  });

  return formCopy;
};
export const getOmniWidgetBaseURL = () => {
  const queryParams = `?lob=BROADBAND&pageName=B2B_FEASIBILITY&requestorSource=B2B&source=ATB_UNAUTH&product=${getProductType(true)}`;
  if (config.env !== ENV_NAME.PROD) {
    // return 'https://airtelp2p.bsbportal.com/omniwidget-desktop-final' + queryParams;
    // return 'https://airtelp2p.bsbportal.com/omni-serviceability' + queryParams;
    // return 'http://localhost:3001/omniwidget.html' + queryParams;
    return `${process.env.PUBLIC_URL}/omniwidget.html` + queryParams;
  } else {
    const winLocation = window?.location?.origin ?? '';
    return `${winLocation}/omni-serviceability/` + queryParams;
  }
};

export const tranformCustomerDetail = (customerDetailsFormState) => {
  return {
    companyName: customerDetailsFormState?.companyName?.value,
    customerName: customerDetailsFormState?.fullName?.value,
    phoneNumber: customerDetailsFormState?.phoneNumber?.value,
    email: customerDetailsFormState?.emailAddress?.value,
    code: '',
    otpSuccess: false,
    uniqueId: correlation(),
    leadSource: 'ONLINE_FEASIBILITY_CHECK'
    // partyId: findParamFromUrl('partyId', false)
  };
};

export const getb2cSessionData = () => {
  const sessionKey = 'persist:omniWidgetPersistedStore';
  const b2cSessionData = sessionStorage?.getItem(sessionKey);

  return JSON.parse(b2cSessionData);
};

export const transformFeasibilityResponse = (feasibilityResponse, leadData, userFilledPincode) => {
  const { addressReducer } = getb2cSessionData();
  const { pincode } = JSON.parse(addressReducer);

  const defaultPayload = {
    code: '',
    otpSuccess: false,
    uniqueId: correlation(),
    leadSource: 'ONLINE_FEASIBILITY_CHECK'
    // partyId: findParamFromUrl('partyId', false)
  };

  // lead response updates
  if (leadData?.authorizedSignatory?.companyName) {
    defaultPayload['companyName'] = leadData?.authorizedSignatory?.companyName;
  }

  if (leadData?.authorizedSignatory?.firstName && leadData?.authorizedSignatory?.lastName) {
    defaultPayload['customerName'] = leadData?.authorizedSignatory?.firstName + ' ' + leadData?.authorizedSignatory?.lastName;
  }

  if (leadData?.authorizedSignatory?.phoneNumber) {
    defaultPayload['phoneNumber'] = leadData?.authorizedSignatory?.phoneNumber;
  }

  if (leadData?.authorizedSignatory?.email) {
    defaultPayload['email'] = leadData?.authorizedSignatory?.email;
  }

  // feasibility response updates
  defaultPayload['cityName'] = feasibilityResponse?.address?.city;
  defaultPayload['address'] = feasibilityResponse?.address?.addressString;
  defaultPayload['feasibilityStatus'] = feasibilityResponse?.feasibilityStatus;
  defaultPayload['pinCode'] = userFilledPincode ?? pincode;

  return defaultPayload;
};

const handleCreateSiebelLead = (isdedicatedJourney, cb, { auth_token, showNotification }) => {
  createSiebelLead(isdedicatedJourney, auth_token)
    .then((_response) => {
      cb?.();
      trackGTM('otpSubmitted', 'forme|internet_leased_line|leadpage');
      if (auth_token) {
        setInSessionStorage(MODULE_ID, AUTHORIZATION_HEADER, auth_token);
        localStorage?.setItem('storageTime', new Date()?.toString());
      }
    })
    .catch((err) => {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      // BugFix: BB-13514
      // showNotification?.(true, errorMsg, NOTIFICATION_TYPE.ERROR);
      console?.error(errorMsg);
    });
};

export const createUpdateUnauthLead = (payload, isdedicatedJourney, cb, { setLoader, showNotification }) => {
  const authToken = getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
  let updateCustomerData = authToken ? true : false;

  setLoader?.(true);

  createLead(payload, updateCustomerData, isdedicatedJourney)
    .then((response) => {
      const productType = getProductType();
      const segment = response?.data?.result?.customerSegment;
      const auth_token = response?.headers?.authorization_token;

      setLoader?.(false);

      if (!updateCustomerData) {
        saveLead(response?.data?.result);
        handleCreateSiebelLead(isdedicatedJourney, cb, { auth_token, showNotification });
      } else {
        // success callback after create cocp and siebel lead/ update lead
        cb?.();
      }

      // if (auth_token) {
      //   setInSessionStorage(MODULE_ID, AUTHORIZATION_HEADER, auth_token);
      //   localStorage?.setItem('storageTime', new Date()?.toString());
      // }

      if (!updateCustomerData && segment) {
        faOnDedicatedAuthCheckFeasibiliyPage({ segment, productType });
      }

      gtag_report_conversion_lead_submitted();
    })
    .catch((err) => {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      setLoader?.(false);
      // showNotification?.(true, errorMsg, NOTIFICATION_TYPE.ERROR);
    });
};

export const handleUnauthAddDiConnections = (payload, cb, { setLoader, showNotification }) => {
  setLoader?.(true);

  trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.UNAUTH_SUBMIT_PLAN, { bandwidth: payload?.[0]?.planDetail?.speed, service: '', contractPeriod: '' });

  addDiConnectionDetails(payload)
    .then((response) => {
      setLoader?.(false);
      cb?.(response);
    })
    .catch((err) => {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      setLoader?.(false);
      showNotification?.(true, errorMsg, NOTIFICATION_TYPE.ERROR);
    });
};

export const getBandwithValueInMbps = (bandwidth) => {
  if (bandwidth?.includes('Mbps')) {
    const splittedBwArr = bandwidth?.split('Mbps');

    return parseInt(splittedBwArr?.[0]);
  }

  if (bandwidth?.includes('Gbps')) {
    const splittedBwArr = bandwidth?.split('Gbps');

    return parseInt(splittedBwArr?.[0]) * 1024;
  }
};

export const getImageSrc = (plan) => {
  switch (plan.bandwidth) {
    case '10Mbps': {
      return MeterImg1;
    }
    case '50Mbps': {
      return MeterImg2;
    }
    case '100Mbps': {
      return MeterImg3;
    }
    case '200Mbps': {
      return MeterImg4;
    }
    case '1Gbps': {
      return MeterImg5;
    }
    default: {
      return MeterImg5;
    }
  }
};
export const isOrderSubmittedByCustomer = (orderStatus) => {
  const orderOvRejected = orderStatus === ORDER_TYPE.OV_REJECTED;
  const orderSubmitted = orderStatus === ORDER_TYPE.ORDER_SUBMITTED && !orderOvRejected;

  let currentOrderSubmittedStatus = false;

  // ORDER_SUBMITTED_POST_STATUS = ['OV_', ...]. Special handling for 'OV_REJECTED' case.
  if (orderOvRejected) {
    return false;
  }

  ORDER_SUBMITTED_POST_STATUS.forEach((item) => {
    if (orderStatus?.toLowerCase()?.includes(item?.toLowerCase())) {
      currentOrderSubmittedStatus = true;
    }
  });

  if (orderSubmitted || currentOrderSubmittedStatus) {
    return true;
  }

  return false;
};

export const isSingleUpgradeOrShiftingJourney = () => {
  const lsi = findParamFromUrl('lsi', false);
  const partyId = findParamFromUrl('partyId', false);

  if (lsi && partyId) {
    return true;
  }

  if (isShiftingJourney()) {
    return true;
  }

  return false;
};

export const filterAccounts = (accounts = [], partyId = '') => {
  return accounts
    .map((rawAccount) => {
      if (rawAccount?.rootAccountNumber === rawAccount?.parentAccountNumber) {
        return { ...rawAccount, parentAccountNumber: rawAccount?.accountNumber };
      }
      return rawAccount;
    })
    .filter((rawAccount) => {
      return rawAccount?.parentAccountNumber !== partyId;
    });
};

export const getPreviousYearDate = (noOfYearsBack = 0) => {
  let date = new Date();
  date.setFullYear(date.getFullYear() - noOfYearsBack);
  return date;
};

export const checkIfItemCodePresentInSiteSpecs = (siteSpecs) => {
  let isPresent = false;

  if (Array.isArray(siteSpecs) && siteSpecs?.length > 0) {
    const itemCode = siteSpecs?.find((item) => item['name'] === 'itemCode');

    if (itemCode) {
      isPresent = true;
    } else {
      isPresent = false;
    }
  }

  return isPresent;
};

export const isFormTouched = (form) => {
  let isTouched = false;
  if (form) {
    for (let item in form) {
      let value = form[item];
      if (value && Object.prototype.toString.call(value) === '[object Object]' && value.hasOwnProperty('touched') && value['touched']) {
        isTouched = true;
        break;
      }
    }
  }

  return isTouched;
};

export const disableBrowserBackButton = () => {
  window.history.pushState(null, null, document.URL);
  window.addEventListener('popstate', function () {
    window.history.pushState(null, null, document.URL);
  });
};

export const getAddress = (address) => {
  const { line1, line2, city, country, pincode, state } = address || {
    line1: '',
    line2: '',
    city: '',
    country: '',
    pincode: '',
    state: ''
  };

  let completeAddress = '';

  if (line1) {
    completeAddress += `${line1}, `;
  }
  if (line2) {
    completeAddress += `${line2}, `;
  }
  if (city) {
    completeAddress += `${city}, `;
  }
  if (state) {
    completeAddress += `${state}, `;
  }
  if (country) {
    completeAddress += `${country}, `;
  }
  if (pincode) {
    completeAddress += `${pincode}`;
  }

  return completeAddress;
};

export const isAddressValid = (value) => {
  let isValid = false;
  if (value.match(/^(([A-Za-z0-9 \/,*_:"-])+)?$/)) {
    isValid = true;
  }
  return isValid;
};
export function enablePlatformLogin() {
  return localStorage.getItem("platformVariant") == "B";
}